import { Injectable } from '@angular/core';
import { EnumOperator } from '../models/FieldValidator';

@Injectable({
    providedIn: 'root'
})
export class UtilsService {
    private timezoneoffset = (new Date()).getTimezoneOffset() * 60000;

    public GetLocalISODate(time:number):string
    {
       return new Date(time - this.timezoneoffset).toISOString().slice(0, 10);
    }
    public GetLocalISODateTime(time:number):string
    {
       return new Date(time - this.timezoneoffset).toISOString().slice(0, -1);
    }
    public AddMinutes(time, minsToAdd) {
      function D(J){ return (J<10? '0':'') + J;};
      var piece = time.split(':');
      var mins = piece[0]*60 + +piece[1] + +minsToAdd;
    
      return D(mins%(24*60)/60 | 0) + ':' + D(mins%60);  
    }  
    public SubstractMinutes(time, minsToAdd) {
      function D(J){ return (J<10? '0':'') + J;};
      var piece = time.split(':');
      var mins = piece[0]*60 - -piece[1] - -minsToAdd;
    
      return D(mins%(24*60)/60 | 0) + ':' + D(mins%60);  
    }  

    public minutesToHoursConvert(n) {
      let num = n;
      let hours = (num / 60);
      let rhours = Math.floor(hours);
      let minutes = (hours - rhours) * 60;
      let rminutes = Math.round(minutes);
      return [rhours, rminutes];
    }

    public getNumberOfWeek(date) {
      const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      const pastDaysOfYear = (date.getTime() - firstDayOfYear.getTime()) / 86400000;
      return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
    }
    
    public firstDayOfWeek(date) {
      let first = date.getDate() - date.getDay() + 1; 
      return new Date(date.setDate(first));
    }

    public Timezone() : any {
      //var DateNow = new Date();
      let jan1 : any = new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0);
      let temp = jan1.toUTCString();
      let UTC = temp.substring(temp.lastIndexOf(" ") + 1, temp.length);
      let jan2 : any = new Date(temp.substring(0, temp.lastIndexOf(" ") - 1));
      let std_time_offset = (jan1 - jan2) / (1000 * 60 * 60);
      let timeZone = UTC + std_time_offset;
      return timeZone;
    }

    public calcCrow(lat1, lon1, lat2, lon2) 
    {
      let R = 6371; // km
      let dLat = this.toRad(lat2-lat1);
      let dLon = this.toRad(lon2-lon1);
      let latitud1 = this.toRad(lat1);
      let latitud2 = this.toRad(lat2);

      var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(latitud1) * Math.cos(latitud2); 
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
      var d = R * c;
      return d;
    }

    // Converts numeric degrees to radians
    private toRad(Value) {
        return Value * Math.PI / 180;
    }

    public RequiredFields(req: Array<any>) {
      let result = [];
      let count = req.length;
      for (let index = 0; index <= count - 1; index ++) {
        let r = req[index];
        if (r.condition) {
          if (r.object[r.model] == null || r.object[r.model] == {} || r.object[r.model] === '' ||
              (r.operator == EnumOperator.DifferentFrom ? !r.checkValue.includes(r.object[r.model]) : 0 !== 0) ||
              (r.operator == EnumOperator.Equals ? r.checkValue.includes(r.object[r.model]) : 0 !== 0) ||
              (r.operator == EnumOperator.MoreThan ? r.object[r.model] > r.checkValue : 0 !== 0) ||
              (r.operator == EnumOperator.LessThan ? r.object[r.model] < r.checkValue : 0 !== 0)) {
            if (r.component[r.element]) 
              if(r.component[r.element].required)
                r.component[r.element].labelAppearance += " fieldRequired"
              else
                r.component[r.element].nativeElement.classList.add('fieldRequired');
            result.push({ component: r.component, element: r.element });
          }
          else {
            if (r.component[r.element]) 
              if(r.component[r.element].required)
                r.component[r.element].labelAppearance = r.component[r.element].labelAppearance.replace(" fieldRequired", "")
              else
                r.component[r.element].nativeElement.classList.remove('fieldRequired');
          }
        }
        else {
          if (r.component[r.element]) 
            if(r.component[r.element].required)
              r.component[r.element].labelAppearance = r.component[r.element].labelAppearance.replace(" fieldRequired", "")
            else
              r.component[r.element].nativeElement.classList.remove('fieldRequired');
        }
      }
      return result;
    }

    public checkState(event, el, object, prop, defaultValue = undefined) {
      event.preventDefault();
        if (typeof object[prop] !== 'undefined' && object[prop] === el.value) {
          el.checked = false;
          object[prop] = defaultValue;
        } else {
          object[prop] = el.value
          el.checked = true;
        }      
    }
}